import React from 'react';
import { Carousel } from '@one-thd/sui-carousel';
import { string } from 'prop-types';
import QuotesDetailsBox from './QuotesDetailsBox';
import QuotesNullView from './QuotesNullView/QuotesNullView';
import { quotesPropType } from '../../utils/propTypes';
import { BREAKPOINTS } from '../../constants/responsiveClassNames';
import { useQuoteContext } from '../../hooks/useQuoteContext';

const QuotesCarousel = ({ quotes, componentId }) => {
  const { containerWidth } = useQuoteContext();

  // Helper function to check if we should show fallback content
  const shouldShowFallback = () => {
    if (quotes.length > 2) {
      return false;
    }

    if (quotes.length === 1) {
      return containerWidth >= BREAKPOINTS.FALLBACK_SM;
    }

    if (quotes.length === 2) {
      return containerWidth >= BREAKPOINTS.FALLBACK_MD;
    }

    return false;
  };

  // Default: render quotes in carousel for all other cases
  const quotesCards = quotes?.map((quote, index) => (
    <QuotesDetailsBox
      key={`${quote.cartId}-${index}`}
      quote={quote}
      lastSlide={index === quotes.length - 1}
      index={index}
      componentId={componentId}
    />
  ));

  if (shouldShowFallback()) {
    quotesCards.push(
      <QuotesNullView
        carousel
        key="quotes-fallback-content"
        componentId={componentId}
      />
    );
  }

  return (
    <Carousel
      type="peek"
      layout="full-bleed"
      containerId="quotes-carousel"
      slidesPerView="auto"
      slidesPerGroup={1}
      spaceBetween={0}
      breakpoints={{
        sm: { slidesPerGroup: 1, slidesPerView: 'auto' },
        md: { slidesPerGroup: 1, slidesPerView: 'auto' },
        lg: { slidesPerGroup: 1, slidesPerView: 'auto' },
        xl: { slidesPerGroup: 1, slidesPerView: 'auto' },
        '2xl': { slidesPerGroup: 1, slidesPerView: 'auto' },
      }}
      disableMargin
    >
      {quotesCards}
    </Carousel>
  );
};
QuotesCarousel.propTypes = {
  quotes: quotesPropType,
  componentId: string,
};

QuotesCarousel.defaultProps = {
  quotes: [],
  componentId: '',
};

export default QuotesCarousel;
